/**
@license
Copyright (c) 2023 Advensys LLC. All rights reserved.
*/

import {
  createSlice
} from '@reduxjs/toolkit'

import { createSelector } from 'reselect';
import {dataurl} from '../components/paksh-constants.js'

const initialState = {
  isFetching: false,
  failure: false,
  items: {},
  query : null
};

export const searchLawyers = (query) => (dispatch, getState) => {
  // Check to see if the cached results are from the same query.
  // This is useful for avoiding a network request.
  console.log("search Lawyesr",query)
  if (shouldSearchLawyers(getState(), query)) {
    dispatch(lawyersRequested(query));
    console.log("fetching lawyers")
    let token = window.localStorage.getItem('token');
    // console.log(token)
    if (query) {
      fetch(`${dataurl}/lawyers?q=${query}`, {
        method: 'GET',
        headers: {
          'x-access-token': token,
        }
        })
        .then(res => res.json())
        .then(data => dispatch(lawyersReceived(data.lawyers)))
        .catch(() => dispatch(lawyersFailed(query)));
        console.log("fetched lawyer data")
        //console.log(data)
    } else {
      // query is empty, clear the results
      dispatch(lawyersReceived());
    }
  }
};

const shouldSearchLawyers = (state, query) => {
  // console.log(state.lawyers.query + query + state.lawyers.isFetching)
  return  state.lawyers.failure || state.lawyers.query !== query && !state.lawyers.isFetching;
}



export const lawyersSelector = state => state.lawyers && state.lawyers.items;

export const lawyerListSelector = createSelector(
  lawyersSelector,
  (items) => items ? Object.keys(items).map(key => items[key]) : ""
);

export const lawyersSlice = createSlice({
  name: 'lawyers',
  initialState,
  reducers: {
    lawyersRequested(state, action) {
      state.query = action.payload;
      state.items = null;
      state.failure = false;
      state.isFetching = true;
    },
    lawyersReceived(state, action) {
      state.items = action.payload.reduce((obj, item) => {
        obj[item.id] = item;
        return obj;
      }, {}),
      state.failure = false;
      state.isFetching = false;
    },
    lawyersFailed(state, action) {
      console.log("in lwayersFailed -layersSlice")
      state.items= null;
      state.failure = true;
      state.isFetching = false;
    },
    lawyersUpdated(state, action) {
      state.items = action.payload.reduce((obj, item) => {
        obj[item.id] = item;
        return obj;
      }, {}),
      state.failure = false;
      state.isFetching = false;
    },
  },
})

export const { lawyersRequested, lawyersReceived, lawyersFailed, lawyersUpdated } = lawyersSlice.actions

// Export the slice reducer as the default export
export default lawyersSlice.reducer